import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-64ab98ca"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  id: "mapPage",
  width: "100%",
  height: "100%",
  frameborder: "0",
  src: "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=PL7BZ-QDQRP-X4GDK-VS632-IXOE6-JQFZS&referer=myapp"
}, " ", -1));

import { nextTick, ref } from 'vue';
import debounce from 'lodash/debounce';
import { qqmap_getCurrentPosition, qqmap_reverseGeocoder } from '@/api/qqmap';
export default {
  emits: ['selectLocation'],

  setup(__props, {
    emit: emits
  }) {
    let map = null;
    let local = null; // eslint-disable-next-line no-undef
    // const BMap = BMapGL

    nextTick(() => {
      // map = new BMap.Map('map')
      // map.centerAndZoom(new BMap.Point(113.129538, 22.973782), 11)
      // local = new BMap.LocalSearch(map, {
      //   onSearchComplete: () => {
      //     results.value = local.getResults() ? local.getResults()._pois : []
      //   }
      // })
      window.addEventListener('message', function (event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;

        if (loc && loc.module == 'locationPicker') {
          //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          console.log('location', loc);

          if (loc.poiname == '我的位置') {
            qqmap_reverseGeocoder(`${loc.latlng.lat},${loc.latlng.lng}`).then(res2 => {
              // console.log(res2)
              selectLocation({
                title: res2.result.address,
                point: {
                  lat: res2.result.location.lat,
                  lng: res2.result.location.lng
                }
              });
            });
          } else {
            selectLocation({
              title: loc.poiname,
              point: {
                lat: loc.latlng.lat,
                lng: loc.latlng.lng
              }
            });
          }
        }
      }, false);
    }); // 结果数组

    const results = ref([]);
    const show = ref(false);
    const searchValue = ref('');

    function openSheet() {
      show.value = true;
      nextTick(() => {
        console.log('searchView1', document.getElementById('searchView').offsetTop);
        document.getElementById('searchView').scrollTop = 0;
      });
    }

    const handleChange = debounce(value => {
      local.search(value, {
        forceLocal: true
      });
    }, 500); // 选择地点

    function selectLocation(item) {
      if (!item) {
        // 不显示
        results.value = [];
        searchValue.value = '';
      }

      emits('selectLocation', item);
      show.value = false;
    }

    return (_ctx, _cache) => {
      const _component_van_action_sheet = _resolveComponent("van-action-sheet");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "open-btn",
        onClick: openSheet
      }, [_renderSlot(_ctx.$slots, "default")]), _hoisted_1, _createVNode(_component_van_action_sheet, {
        class: "search-sheet",
        id: "searchView",
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => show.value = $event),
        title: ""
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }

};